/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  List,
  SiteChannel,
  SiteChannelRole,
  SiteChannelSetup,
} from "./data-contracts";

/**
 * @description Returns a paginated list of channels configured for the site. Channels are integrations that allow GitBook Agent to operate within external tools your team already uses, bringing documentation assistance directly into existing workflows. Each channel has a role that determines whether the Agent answers questions from the site's documentation or actively collaborates by opening and managing content changes. Use this to inspect or manage the Agent channel integrations for a site.
 * @tags site-channels
 * @name ListSiteChannels
 * @summary List all GitBook Agent channels for a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/channels
 * @secure
 */

// @ts-ignore
export const listSiteChannels: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteChannel[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/channels",
  method: "get",
  streaming: false,
  tags: ["site-channels"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Configures a new channel integration that allows GitBook Agent to operate within an external tool connected to this site. The channel role determines whether the Agent acts as a support assistant — answering questions sourced from the site's documentation — or as a collaborator that can open change requests and sync documentation updates directly from the connected platform.
 * @tags site-channels
 * @name CreateSiteChannel
 * @summary Create a new GitBook Agent channel for a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/channels
 * @secure
 */

// @ts-ignore
export const createSiteChannel: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: SiteChannelSetup & {
    role?: SiteChannelRole;
  };
  RequestHeaders: {};
  ResponseBody: SiteChannel;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/channels",
  method: "post",
  streaming: false,
  tags: ["site-channels"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Lists accessible Linear teams, GitHub repositories, Slack channels or Jira projects. Requires site admin permission. Linear, GitHub and Slack require an already-connected channel belonging to this site and matching the provider. Jira uses either the credentials supplied, verified without saving a connection, or those stored on an existing Jira context connection of this site. Slack includes public channels and accessible private channels, excluding archived channels. To fetch another page, pass the opaque token from `next.page` as the `page` query parameter with the same request body. An absent `next` means there are no more pages; an empty `items` array alone does not indicate the end of the list.
 * @tags site-channels
 * @name ListSiteChannelScopes
 * @summary List available site channel scopes
 * @request POST:/orgs/{organizationId}/sites/{siteId}/channels/scopes
 * @secure
 */

// @ts-ignore
export const listSiteChannelScopes: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
  };
  RequestBody:
    | {
        provider: "linear";
        /** ID of an already-connected channel belonging to this site and matching the provider. */
        siteChannelId: string;
      }
    | {
        provider: "github";
        /** ID of an already-connected channel belonging to this site and matching the provider. */
        siteChannelId: string;
      }
    | {
        provider: "slack";
        /** ID of an already-connected channel belonging to this site and matching the provider. */
        siteChannelId: string;
      }
    | {
        provider: "jira";
        /** ID of a Jira context connection belonging to this site, whose stored credentials are used. */
        siteContextConnectionId: string;
      }
    | {
        provider: "jira";
        credentials: {
          /**
           * Base URL of the Jira Cloud site, e.g. https://your-team.atlassian.net.
           * @format uri
           * @minLength 1
           * @maxLength 2048
           */
          baseUrl: string;
          /**
           * Email of the Atlassian account whose API token is used.
           * @format email
           * @minLength 1
           * @maxLength 254
           */
          apiEmail: string;
          /**
           * Atlassian API token used to verify the account and list accessible projects. Not saved.
           * @minLength 1
           * @maxLength 1024
           */
          apiToken: string;
        };
      };
  RequestHeaders: {};
  ResponseBody: List & {
    object: "site-channel-scopes";
    /** Linear workspace name, GitHub account name, Slack workspace name (or ID if unavailable), or Jira Cloud hostname. */
    connection: string;
    items: {
      /** Value accepted by the provider scope settings, such as a team key, repository full name, channel name, Jira project key. */
      key: string;
      name: string;
    }[];
  };
  ResponseStatusCode: 200 | 400 | 401 | 403 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/channels/scopes",
  method: "post",
  streaming: false,
  tags: ["site-channels"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves the configuration of a specific GitBook Agent channel integration, including its connected platform type and role. Use this to inspect or verify the channel's setup before updating it.
 * @tags site-channels
 * @name GetSiteChannelById
 * @summary Get a GitBook Agent channel for a site by its ID
 * @request GET:/orgs/{organizationId}/sites/{siteId}/channels/{siteChannelId}
 * @secure
 */

// @ts-ignore
export const getSiteChannelById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site channel */
    siteChannelId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteChannel;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/channels/{siteChannelId}",
  method: "get",
  streaming: false,
  tags: ["site-channels"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Modifies the configuration of a specific GitBook Agent channel integration, including its role. Use this to change whether the Agent answers documentation questions or actively collaborates on content changes through the connected platform.
 * @tags site-channels
 * @name UpdateSiteChannelById
 * @summary Update a GitBook Agent channel for a site
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/channels/{siteChannelId}
 * @secure
 */

// @ts-ignore
export const updateSiteChannelById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site channel */
    siteChannelId: string;
  };
  RequestQuery: {};
  RequestBody:
    | SiteChannelSetup
    | {
        role?: SiteChannelRole;
      };
  RequestHeaders: {};
  ResponseBody: SiteChannel;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/channels/{siteChannelId}",
  method: "patch",
  streaming: false,
  tags: ["site-channels"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Removes the channel configuration from the site, so GitBook Agent stops answering and collaborating through the connected platform. The app itself is not uninstalled and its access is not revoked on the platform, so remove it there as well to fully disconnect.
 * @tags site-channels
 * @name DeleteSiteChannelById
 * @summary Delete a GitBook Agent channel from a site
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/channels/{siteChannelId}
 * @secure
 */

// @ts-ignore
export const deleteSiteChannelById: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site channel */
    siteChannelId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/channels/{siteChannelId}",
  method: "delete",
  streaming: false,
  tags: ["site-channels"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
